
import { VehicleData } from '@/types';
import { Car, Copy } from 'lucide-react';
import React from 'react';
import { toast } from 'sonner';

interface UserVehicleChipProps {
  vehicleData: VehicleData;
  compact?: boolean;
}

const UserVehicleChip: React.FC<UserVehicleChipProps> = ({ vehicleData, compact = false }) => {
  const handleCopy = React.useCallback(() => {
    const vehicleText = vehicleData.vin 
      ? `VIN: ${vehicleData.vin}` 
      : `${vehicleData.year} ${vehicleData.make} ${vehicleData.model}`;
    navigator.clipboard.writeText(vehicleText);
    toast.success('Vehicle data copied to clipboard');
  }, [vehicleData]);

  const displayText = vehicleData.vin 
    ? `VIN: ${vehicleData.vin}` 
    : `${vehicleData.year} ${vehicleData.make} ${vehicleData.model}`;

  return (
    <div className={`user-vehicle-chip ${compact ? 'compact' : ''}`}>
      <div className="vehicle-chip-content">
        <div className="vehicle-chip-icon">
          <Car size={compact ? 12 : 14} />
        </div>
        <span className="vehicle-chip-text">{displayText}</span>
      </div>
      <button
        className="vehicle-chip-copy"
        onClick={handleCopy}
        aria-label="Copy vehicle data"
      >
        <Copy size={compact ? 10 : 12} />
      </button>
    </div>
  );
};

export default UserVehicleChip;
